import { Container } from "react-bootstrap";
import Invigilator from "./invigilator";

export default function InvigilatorIndex() {
    return (
        <Container>
            <Invigilator />
        </Container>
    )
}